import React from 'react'
import { Form } from 'react-bootstrap'

function CodePrettier(props) {

    // handle code
    const handleCode = () => {
        var text = document.getElementById("codearea").value
        text = `<plaintext>${text}`
        props.callFunction(text);
    }

    return (
        <Form.Group>
               <Form.Control id="codearea" onChange={handleCode} as='textarea' type="text/palin" rows={3} placeholder='Your code...  (optional)' />
        </Form.Group>
    )
}

export default CodePrettier
